export const PRODUCT_CATEGORIES = [
  { value: 'KIDS', label: 'Kids Play' },
  { value: 'FAMILY', label: 'Family Play' },
];
